const DIAGNOSIS_REGISTER_ACCEPTANCE_TERM_KEY =
  '@atlas:v1:diagnosis-register-acceptance-term'

export function saveDiagnosisRegisterAcceptanceTerm(
  acceptanceTerm: boolean,
): void {
  localStorage.setItem(
    DIAGNOSIS_REGISTER_ACCEPTANCE_TERM_KEY,
    JSON.stringify(acceptanceTerm),
  )
}

export function getDiagnosisRegisterAcceptanceTerm(): boolean {
  const acceptanceTerm = localStorage.getItem(
    DIAGNOSIS_REGISTER_ACCEPTANCE_TERM_KEY,
  )

  if (acceptanceTerm) {
    return JSON.parse(acceptanceTerm)
  }

  return false
}
